import { Box, Container, Heading, Stack, Text } from "@chakra-ui/react"
import styled from "styled-components"
import ISt from '../../assets/image/istlogo.png'
import MpLogo from '../../assets/image/logoMP.png'
import QatrosLogo from '../../assets/image/Qatros.png'

const GridStyled = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 16px;
  align-items: center;
`

const StyledImage = styled.img`
  max-width: 100px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

const Experience = () => {
  return (
    <Container backgroundColor={'#f7f8fd'} maxW={'9xl'} style={{
      marginTop: '-60px'
    }}>
      <Stack
        as={'Box'}
        textAlign={'center'}
        spacing={{ base: 8, md: 14 }}
        py={{ base: 10, md: 36 }}
      >
        <Heading
          lineHeight={1.1}
          fontWeight={600}
          fontSize={{ base: "3xl", sm: "4xl", lg: "6xl" }}
        >
          <Text as={'span'} color={"#2347f9"}>
            Experience Company
          </Text>
        </Heading>

        <Box alignContent={'center'}>
          <GridStyled>
            <StyledImage onClick={() => window.open('https://www.ist.id/')} src={ISt} alt={'ist logo'} />
            <StyledImage onClick={() => window.open('https://muslimpergi.com/')} src={MpLogo} alt={'mp logo'} />
            <StyledImage onClick={() => window.open('https://qatros.com/')} src={QatrosLogo} alt={'qatros logo'} />
          </GridStyled>
        </Box>
      </Stack>
    </Container>
  )
}

export default Experience